export default __webpack_public_path__ + "static/media/Mark-3-Suit-00.c7d58015.jpg";